<style>
.bg-primary {
  background-color: #1a3665 !important;
}
</style>
<template>
  <CCard>
    <CCardHeader class="bg-primary text-white d-flex align-items-center font-weight-bold">
      Kategori Anggota
      <template v-if="role_status && role_status.status_create">
        <CButton
        color="success"
        style="float:right"
        class="btn-md ml-auto"
        @click="createData()"
        >Tambah</CButton>
       </template>
    </CCardHeader>
    <!-- Data Sertifikasi -->
    <CCardBody>
      <CRow>
        <CCol xl="12">
          <CSelect
            label="Data Perhalaman"
            class="float-left"
            @change="changePageSize"
            :options="[10, 25, 100, 'Semua Data']"
          />
          <CInput
            label="Pencarian"
            class="float-right"
            placeholder="Cari Data .."            
            v-model="search"
          />
          <br />
        </CCol>
      </CRow>
      <CRow>
        <CCol lg="12" class="table-responsive">
          <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
            <template #no="{index}">
              <td class="py-2">{{indexed == 0 ? index +1: index+indexed + 1}}</td>
            </template>

            <template #namaKategori="{item}">
              <td class="py-2 text-left">{{item.namaKategori ? item.namaKategori : "-"}}</td>
            </template>
            <template #targetSkpWajib="{item}">
              <td class="py-2 text-center font-weight-bold">{{ item.targetSkpWajib }}</td>
            </template>
            <template #targetSkpNonWajib="{item}">
              <td class="py-2 text-center font-weight-bold">{{ item.targetSkpNonWajib }}</td>
            </template>
            <template #akumulasiTargetSkp="{item}">
              <td class="py-2 text-center font-weight-bold">{{ item.akumulasiTargetSkp }}</td>
            </template>
            <template #status="{item}">
              <td class="py-2 text-center">
                <font-awesome-icon icon="check" class="text-success" v-if="item.status == 1" />
                <font-awesome-icon icon="times" class="text-danger" v-else />
              </td>
            </template>
            <template #aksi="{item, index}">
              <td class="py-2 text-center">
                <template v-if="role_status && role_status.status_update">
                <CButton v-c-tooltip="'Ubah'" color="info" square size="sm" @click="updateData(item, index)">
                  <font-awesome-icon icon="edit" />
                </CButton>&nbsp;&nbsp;
                </template>
                <template v-if="role_status && role_status.status_delete">
                <CButton v-c-tooltip="'Hapus'" color="danger" square size="sm" @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash" />
                </CButton>
                </template>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float:right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @change="pageChange"
          />
        </CCol>
      </CRow>
      <!-- Modal Tambah -->
      <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CForm v-on:submit.prevent="postData">
          <CRow>
            <CCol sm="12">
              <label for="" class="font-weight-bold">Nama Kategori</label>
              <input
                class="form-control"
                placeholder="Masukkan Nama Kategori"
                v-model="formData.namaKategori"
                id="namaKategori"
                @input="setNamaKategori($event.target.value)"
                :class="{
                  'is-invalid': $v.formData.namaKategori.$error,                   
                }"
              />              
            </CCol>
            <CCol sm="12" class="mt-3">
              <label for="" class="font-weight-bold">Kewajiban SKP Terstruktur</label>
              <input
                class="form-control"
                label="Kewajiban SKP"
                placeholder="Terstruktur"
                type="number"                        
                min="0"
                id="targetSkpWajib"
                v-model="formData.targetSkpWajib"
                @input="setTargetSkpWajib($event.target.value)"
                :class="{
                  'border-danger': $v.formData.targetSkpWajib.$error,                   
                }"
              />
            </CCol>
            <CCol sm="12"  class="mt-3">
              <label for="" class="font-weight-bold">Kewajiban SKP Non Terstruktur</label>
              <input
                class="form-control"
                placeholder="SKP Non Terstruktur"
                type="number"
                min="0"
                id="target_terstruktur"
                v-model="formData.targetSkpNonWajib"
                @input="setTargetSkpNonWajib($event.target.value)"
                :class="{
                  'border-danger': $v.formData.targetSkpNonWajib.$error,                   
                }"
              />              
            </CCol>
            <CCol sm="12" class="mt-3">
              <label for="" class="font-weight-bold">Akumulasi Kewajiban SKP</label>
              <input
                placeholder="Akumulasi"
                type="number"
                min="0"
                class="form-control"
                readonly                
                v-model="total"
              />
            </CCol>

            <CCol sm="12" id="statusKategori" class="mt-3">
              <label for class="font-weight-bold">Status Akses Pengajuan SKP</label>
              <br />
              <div class="d-flex align-items-center">
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadio"
                    value="1"
                    required
                    v-model="formData.statusAksesPengajuanSkp"
                    id="skpAktif"
                  />
                  <label class="custom-control-label" for="skpAktif">Aktif</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadio"
                    value="0"
                    required
                    id="skpNonAktif"
                    v-model="formData.status"
                  />
                  <label class="custom-control-label" for="skpNonAktif">Tidak Aktif</label>
                </div>
              </div>              
              <span class="text-danger" v-show="$v.formData.statusAksesPengajuanSkp.$error">
                *Status Harus Dipilih
              </span>
            </CCol>
            <CCol sm="12 mb-4" id="statusKategori" class="mt-3">
              <label for class="font-weight-bold">Status</label>
              <br />
              <div class="d-flex align-items-center">
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadio"
                    value="1"
                    required
                    v-model="formData.status"
                    id="aktif"
                  />
                  <label class="custom-control-label" for="aktif">Aktif</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadio"
                    value="0"
                    required
                    id="tidak_aktif"
                    v-model="formData.status"
                  />
                  <label class="custom-control-label" for="tidak_aktif">Tidak Aktif</label>
                </div>
              </div>              
              <span class="text-danger" v-show="$v.formData.status.$error">
                *Status Harus Dipilih
              </span>
            </CCol>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">{{title}}</h6>
        </template>
        <template #footer>
          <CButton @click="closeModal" color="danger">Tutup</CButton>
          <CButton @click="postData" type="submit" color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
    </CCardBody>
    <!-- end data kota/kab -->
  </CCard>
</template>
<script>
import KategoriAnggotaService from '@/services/keanggotaan/kategori-anggota.service';
import { required, minValue } from 'vuelidate/lib/validators'
import { AlertUtils } from '@/mixins/AlertUtils'
import { Pagination } from '@/mixins/Pagination'


const fields = [
  { key: "no", _style: "width: 8%" },
  {
    key: "namaKategori",
    label: "Nama Kategori"
  },
  {
    key: "targetSkpWajib",
    label: "Kewajiban SKP Terstruktur"
  },
  {
    key: "targetSkpNonWajib",
    label: "Kewajiban SKP Non - Terstruktur"
  },
  {
    key: "akumulasiTargetSkp",
    label: "Akumulasi Kewajiban SKP"
  },
  { key: "status", _style: " text-align: center" },
  { key: "aksi", _style: "width:15%; text-align: center" }
];

export default {
  mixins: [AlertUtils, Pagination],
  name: "KategoriAnggota",
  data() {
    return {
      validation : {
        namaKategori: false,
        iuranTahunan: false,
        targetSkpWajib: false,
        targetSkpNonWajib: false,
        status: false,
        statusAksesPengajuanSkp: false,
      },
      filter: "",
      items: [],
      fields,
      pageSize: "",
      actionPost: "",
      formData: {
        namaKategori: "",
        iuranTahunan: "",
        targetSkpWajib: 0,
        targetSkpNonWajib: 0,
        status: "",
        statusAksesPengajuanSkp: "",
        idKategoriAnggota: "",
        akumulasiTargetSkp: 1
      },
      pagination: {
        totalPages: 0
      },
      title: "",
      currentPage: 0,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      content: [],
      indexed: 0,
      role_status: null
    };
  },

  validations: {
    formData: {
      namaKategori: { required },      
      targetSkpWajib: {
        required,
        minValue: minValue(0)
      },
      targetSkpNonWajib: { 
        required,
        minValue: minValue(0)
      },
      statusAksesPengajuanSkp: { required },
      status: { required },
    }
  },
  
  mounted() {
    this.roleData();
    this.getData("0", this.pageSize, "default");
  },

  watch: {
    currentPage: function(val) {
      var page = val - 1;
      this.indexed = page * 10;
      this.getData(val - 1, this.pageSize, this.search);
    },
    myModal: function() {
      if(!this.myModal) {
        this.clearValidation();
      }
    }
  },
  computed: {
      total: function() {
        return parseInt(this.formData.targetSkpWajib) + parseInt(this.formData.targetSkpNonWajib) ;
      }
  },
  methods: {
    roleData()
      {
        var user = JSON.parse(localStorage.getItem('user'));
        var data = user.singleData.detail_user.roles.find(el => el.url === this.$route.path );  
        this.role_status = data;
      },
    setNamaKategori(value) {
      this.formData.namaKategori = value;
      this.$v.formData.namaKategori.$touch();
      if(!this.$v.formData.namaKategori.$error) {
        document.getElementById('namaKategori').classList.add('is-valid');
      }
    },
    setTargetSkpWajib(value) {
      this.formData.targetSkpWajib = value;
      this.$v.formData.targetSkpWajib.$touch();
      if(!this.$v.formData.targetSkpWajib.$error) {
        document.getElementById('targetSkpWajib').classList.add('border-success');
      }
    },
    setTargetSkpNonWajib(value) {
      this.formData.targetSkpNonWajib = value;
      this.$v.formData.targetSkpNonWajib.$touch();
      if(!this.$v.formData.targetSkpNonWajib.$error) {
        document.getElementById('target_terstruktur').classList.add('border-success');
      }
    },

    formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },

    targetSkpFunction(e) {
      // comment console console.log(e.target.value);
      this.formData.targetSkpWajib = e.target.value;
      var test =  parseInt(e.target.value) + parseInt(this.formData.targetSkpNonWajib)
      this.formData.akumulasiTargetSkp = test
    },
    hai(){
      return 11;
    },
    targetSkpNonWajibFunction(e) {
      this.formData.targetSkpNonWajib = e.target.value;
      var test =  parseInt(this.formData.targetSkpWajib) + parseInt(e.target.value)
      this.formData.akumulasiTargetSkp = test
      // comment console console.log(test)
    },
    changePageSize(e) {
      // comment console console.log(e.target.value);
      var pageSize = "";

      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData("0", pageSize, this.search);
    },
    cariData() {
      setTimeout(() => {
        this.getData("0", this.pageSize, this.search);
      }, 1000)
    },
    pageChange() {
      this.getData(this.currentPage, this.pageSize, this.search);
    },

    createData() {
      this.myModal = true;            
      this.total = 0;
      this.actionPost = "insert";
      this.title = "Tambah";
    },

    updateData(value, index) {
      this.myModal = true;
      this.formData = value;
      this.actionPost = "update";
      this.total = value.akumulasiTargetSkp;
      this.title = "Edit";
    },

    deleteData(value, index) {
      this.formData = value;
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            KategoriAnggotaService.deleteKategoriAnggota(this.formData)
              .then(response => {
                // comment console console.log(response);
                this.alertDeleteSuccess();
                this.getData("0", this.pageSize, this.search);
              })
              .catch(error => {
                this.alertError(error.response.data.message);
                // comment console console.log(error);
              });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    getData(currentPage, pageSize, filter) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      KategoriAnggotaService.getKategoriAnggota(currentPage, pageSize, filter)
        .then(response => {          
          loader.hide();             
          if(response.data !== "") {
            this.items = response.data.data.content;
            this.pagination.totalPages = response.data.data.totalPages;
            this.currentPage = response.data.data.pageable.pageNumber + 1;
          } else {
            this.items = [];            
          }
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },

    postData() {      
      this.$v.$touch();
      if (this.actionPost == "insert") {        
        if (this.$v.$invalid) {
          return;
        } else {          
          this.insertData(this.formData);          
        }        
      } else if (this.actionPost == "update") {
        if (this.$v.$invalid) {
          return;
        } else {          
          this.putData();
        }                
      }                     
    },

    insertData(formData) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      formData.akumulasiTargetSkp = this.total
      // comment console console.log(formData);
      // comment console console.log("posat");
      KategoriAnggotaService.postKategoriAnggota(formData)
        .then(response => {
          this.myModal = false;
          this.$v.$reset();
          this.alertSuccess();
          this.getData("0", this.pageSize, this.search);
          loader.hide();
          this.clearFormData();
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error.response.data.message);
          this.alertError(error.response.data.message);
        });
    },

    putData() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      // comment console console.log("put");
      // comment console console.log(this.formData);
      this.formData.akumulasiTargetSkp = this.total
      var vm = this;
      KategoriAnggotaService.putKategoriAnggota(this.formData)
        .then(response => {
          loader.hide();
          // comment console console.log("ini edit");
          vm.myModal = false;
          this.$v.$reset();
          vm.alertEditSuccess();
          this.getData("0", this.pageSize, this.search);
          this.clearFormData();
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error);
          vm.alertError(error.response.data.message);
        });
    },

    closeModal() {
      this.myModal = false;      
    },

    clearFormData() {
      this.formData = {
        namaKategori: "",
        iuranTahunan: "",
        targetSkpWajib: "",
        targetSkpNonWajib: "",
        statusAksesPengajuanSkp: "",
        status: "",
        idKategoriAnggota: "",
        akumulasiTargetSkp: 1
      };
    },

    clearValidation() {
      this.$v.$reset();
      document.getElementById('namaKategori').classList.remove('is-valid');
      document.getElementById('targetSkpWajib').classList.remove('is-valid');
      document.getElementById('target_terstruktur').classList.remove('is-valid');
    }
  }
};
</script>